<ng-template #visitFormModal class="modal" let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{'t-visit-form.t-title' | translate}}</h5>
        <button type="button" class="btn btn-close" aria-label="Close" (click)="modal.dismiss()">
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="visitForm" class="row" (ngSubmit)="generateVisitForm()" (keydown.enter)="$event.preventDefault()">
            <div class="form-group mb-2 col-md-6">
                <label for="visitDate">{{'t-visit-form.t-visit-date' | translate}}</label>
                <input type="date" id="visitDate" name="visitDate" class="form-control" required formControlName="date"
                    [ngClass]="{'is-invalid': submitted && form['date'].errors}">

                <div *ngIf="submitted && form['date'].errors" class="invalid-feedback" align="left">
                    <div *ngIf="form['date'].errors['required']">
                        {{'t-mandatory-field' | translate}}
                    </div>
                </div>
            </div>

            <div class="form-group mb-2 col-md-6">
                <label for="visitTime">{{'t-visit-form.t-visit-time' | translate}}</label>
                <input type="time" id="visitTime" name="visitTime" class="form-control" required formControlName="time"
                    [ngClass]="{'is-invalid': submitted && form['time'].errors}">

                <div *ngIf="submitted && form['time'].errors" class="invalid-feedback" align="left">
                    <div *ngIf="form['time'].errors['required']">
                        {{'t-mandatory-field' | translate}}
                    </div>
                </div>
            </div>

            <div class="form-group mb-2 col-md-6">
                <label for="collaborator">{{'t-visit-form.t-responsible' | translate}}</label>

                <input type="text" id="collaborator" name="collaborator" class="form-control" required
                    [ngClass]="{'is-invalid': submitted && form['agent'].errors}"
                    formControlName="agent">

                <div *ngIf="submitted && form['agent'].errors" class="invalid-feedback" align="left">
                    <div *ngIf="form['agent'].errors['required']">
                        {{'t-mandatory-field' | translate}}
                    </div>
                </div>
            </div>

            <div class="form-group mb-2 col-md-6">
                <label for="listingAgent">{{'t-visit-form.t-listing-agent' | translate}}</label>
                <input type="text" id="listingAgent" name="listingAgent" class="form-control" required
                    formControlName="listingAgent"
                    [ngClass]="{'is-invalid': submitted && form['listingAgent'].errors}">

                <div *ngIf="submitted && form['listingAgent'].errors" class="invalid-feedback" align="left">
                    <div *ngIf="form['listingAgent'].errors['required']">
                        {{'t-mandatory-field' | translate}}
                    </div>
                </div>
            </div>

            <div class="form-group mb-2 col-md-6">
                <label for="clientName">{{'t-visit-form.t-client-name' | translate}}</label>

                <input type="text" id="clientName" name="clientName" class="form-control" required
                    formControlName="clientName"
                    [ngClass]="{'is-invalid': submitted && form['clientName'].errors }">

                <div *ngIf="submitted && form['clientName'].errors" class="invalid-feedback" align="left">
                    <div *ngIf="form['clientName'].errors['required']">
                        {{'t-mandatory-field' | translate}}
                    </div>
                </div>
            </div>

            <div class="form-group mb-2 col-md-6">
                <label for="clientContact">{{'t-visit-form.t-client-contact' | translate}}</label>

                <input type="text" id="clientContact" name="clientContact" class="form-control" required
                    formControlName="clientContact"
                    [ngClass]="{'is-invalid': submitted && form['clientContact'].errors }">

                <div *ngIf="submitted && form['clientContact'].errors" class="invalid-feedback" align="left">
                    <div *ngIf="form['clientContact'].errors['required']">
                        {{'t-mandatory-field' | translate}}
                    </div>
                </div>
            </div>

            <div class="align-items-center d-flex justify-content-between modal-actions mt-3">
                <button type="button" [attr.disabled]="spinnerLoading ? true : null" (click)="modal.dismiss()"
                    class="btn btn-secondary">{{'t-cancel' | translate}}</button>

                <button type="submit" [attr.disabled]="spinnerLoading ? true : null"
                    class="btn btn-primary"><span *ngIf="spinnerLoading" class="spinner-border spinner-border-sm me-2"
                        role="status" aria-hidden="true"></span>{{'t-visit-form.t-generate-visit-form' | translate}}
                </button>
            </div>
        </form>
    </div>
</ng-template>

<app-visit-form-template *ngIf="visit" [isEdit]="isEdit" [visit]="visit"
    [entityData]="entityData"></app-visit-form-template>
